/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export const urlMap = {
    '/': true,
    components: { any: true }, // for backward compatibility
    'bid-requests': {
        'pricing-dashboard': true,
        ':bidRequestId': {
            'bid-matrix': {
                variations: true,
            },
            projects: true,
            'procurement-inputs': true,
            'eng-inputs': true,
            scenarios: true,
        },
    },
    plant: {
        compare: true,
        results: true,
        simulate: true,
        batch: {
            simulate: true,
            results: true,
        },
        configurations: {
            compare: true,
        },
        logs: true,
        'net-benefit': {
            ':id': true,
            simulate: true,
        },
        ':id': true,
    },
    'plant-v2': {
        compare: true,
        results: true,
        simulate: true,
        batch: {
            simulate: true,
            results: true,
        },
        configurations: {
            compare: true,
        },
        logs: true,
        'net-benefit': {
            ':id': true,
            simulate: true,
        },
        ':id': true,
    },
    ess: {
        costing: {
            compare: true,
            simulate: {
                ':configId': true,
            },
            configurations: {
                compare: true,
            },
            logs: true,
        },
    },
    pv: {
        pvsim: {
            simulate: true,
            results: true,
            compare: true,
            configurations: {
                compare: true,
            },
        },
        costing: {
            compare: true,
            simulate: true,
            configurations: {
                compare: true,
            },
        },
        logs: true,
    },
    fimo: {
        configurations: {
            new: true,
        },
    },
    projects: {
        ':projectId': {
            batch: {
                ':id': true,
                'merged-results': true,
                simulate: true,
            },
            energyscoring: {
                simulate: true,
                ':id': true,
            },
            'land-scoring': true,
            results: {
                compare: true,
                ':scenarioId': {
                    engineering: true,
                    summary: true,
                    finance: true,
                    'fimo-validation': true,
                },
            },
            'create-parcels': true,
            'met-stations': {
                ':id': {
                    cap: true,
                    soil: true,
                    sat: true,
                },
                compare: true,
            },
            configurations: {
                new: true,
            },
            logs: true,
        },
    },
    opportunities: {
        ':opportunityId': {
            'new-bid-request': true,
        },
    },
    db: {
        weather: {
            ':id': true,
            compare: true,
        },
        pvmodules: {
            new: true,
            ':moduleId': true,
        },
        pvinverters: {
            new: true,
            ':inverterId': true,
        },
        batteries: {
            new: {
                ':batteryId': true,
            },
            ':batteryId': true,
        },
        essinverters: {
            new: {
                ':pcsId': true,
            },
            ':pcsId': true,
        },
        'mv-transformers': {
            new: {
                ':pcsId': true,
            },
            ':pcsId': true,
        },
        prices: {
            new: true,
            ':type': {
                compare: true,
                ':curveId': true,
            },
        },
        energy: {
            new: true,
            ':type': {
                ':dataId': true,
            },
        },
        'hv-costs': {
            new: {
                ':costDatabaseId': true,
            },
            ':costDatabaseId': true,
        },
        h2electrolyzers: {
            new: true,
            ':electrolyzerId': true,
        },
        h2liquefiers: {
            new: true,
            ':liquefierId': true,
        },
        'thermal-generators': {
            new: {
                ':thermalGeneratorId': true,
            },
            ':thermalGeneratorId': true,
        },
        'met-stations': {
            ':id': {
                cap: true,
                soil: true,
                sat: true,
            },
            compare: {
                cap: true,
            },
        },
        'pv-costs': {
            new: {
                ':costDatabaseId': true,
            },
            ':costDatabaseId': true,
        },
        'bess-costs': {
            new: {
                ':costModelId': true,
            },
            ':costModelId': true,
        },
        logs: true,
    },
    notifications: true,
    admin: {
        'system-issues': true,
    },
    agent: {
        ':conversationId': true,
    },
};
//# sourceMappingURL=urlMap.js.map